export const selectDictionaryFieldContext = (state) => {
    if (!state.dictionaryFieldContext ||
        !Object.keys(state.dictionaryFieldContext.contextValues).length) {
        return undefined;
    }
    return state.dictionaryFieldContext.contextValues;
};
